export const MODULE_DISPLAY_NAMES: Record<string, string> = {
  MODULE_EASM: 'Module EASM',
  MODULE_FREE: 'Module Free',
  MODULE_BRANDABUSE: 'Module Brand Abuse',
  MODULE_VULN: 'Module Vulnerabilities',
  MODULE_NOTIFICATIONS: 'Module Notifications',
  MODULE_ADVTHREATINT: 'Module AdvThreat Intelligence',
  MODULE_SUPPLYCHAIN: 'Module Supply Chain',
  MODULE_SECRISK: 'Module SecRisk',
  MODULE_CUSTOMREPORT: 'Module Custom Report',
  MODULE_IDENTITY: 'Module Identity',
  MODULE_ANALYTICS: 'Module Analytics',
  MODULE_AI_AGENT: 'Module AI Agent Karla',
  MODULE_ALERTS_MGMT: 'Module Alerts Management',
  MODULE_VIP_WATCHLIST: 'Module VIP Watchlist',
  MODULE_DRP_SNAPSHOT: 'Module DRP Snapshot',
  MODULE_VIP: 'Module VIP',
  MODULE_SOCIALMEDIA: 'Module Social Media',
  MODULE_APPS: 'Module Apps',
  SERVICE_PREMIUM: 'Service Premium',
  SERVICE_BASE: 'Service Base',
  SERVICE_BASE_DRP: 'Service Base DRP',
  SUPPLY_CHAIN_SOLARA: 'Supply Chain Solara',
};

const HIDDEN_ENTITLEMENTS = new Set(['FLAG_TRIAL']);

export const isDisplayableEntitlement = (code: string): boolean =>
  Boolean(code) && !HIDDEN_ENTITLEMENTS.has(code);

export const formatModuleDisplayName = (code: string): string => {
  if (MODULE_DISPLAY_NAMES[code]) {
    return MODULE_DISPLAY_NAMES[code];
  }

  return code
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
};

const alternatives = new Intl.ListFormat('en', { type: 'disjunction' });

/** Human-readable list of modules any one of which grants access. */
export const formatRequiredModules = (codes: readonly string[]): string =>
  alternatives.format(codes.map(formatModuleDisplayName));
